export default {
  carregamento_de_arquivos: 'carregamento_de_arquivos',
  analise_produtos_da_cotacao: 'analise_produtos_da_cotacao',
  relatorio_compras_baixados: 'relatorio_compras_baixados'
}
